import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { C } from '../lib/theme';

export default function StripeSuccess() {
  const { t } = useTranslation();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    if (!sessionId) { setStatus('error'); return; }
    verify(sessionId);
  }, []);

  async function verify(sessionId) {
    try {
      const res = await fetch(`/api/stripe/verify-session?session_id=${sessionId}`);
      const json = await res.json();
      if (json.ok) {
        setData(json);
        setStatus('ok');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  }

  function goHome() {
    window.location.href = '/';
  }

  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100vh', background: C.cream, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🌿</div>
          <p style={{ color: C.sage, fontFamily: 'Georgia, serif' }}>{t('stripe_success.loading')}</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={{ minHeight: '100vh', background: C.cream, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', padding: '1rem' }}>
        <div style={{ maxWidth: 400, textAlign: 'center', background: '#fff', borderRadius: 16, padding: '2rem', boxShadow: '0 2px 12px rgba(44,106,79,0.08)' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️</div>
          <h2 style={{ fontFamily: 'Georgia, serif', color: C.carbon }}>{t('stripe_success.error_title')}</h2>
          <p style={{ color: C.gray, fontSize: '0.9rem' }}>
            {t('stripe_success.error_pre')} <strong>hola@veraglp.com</strong> {t('stripe_success.error_post')}
          </p>
          <button onClick={goHome} style={{ marginTop: '1rem', padding: '0.8rem 1.5rem', borderRadius: 8, border: 'none', background: C.sage, color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
            {t('stripe_success.error_btn')}
          </button>
        </div>
      </div>
    );
  }

  const isClinic = data?.type === 'clinic';

  const STEPS = [
    t('stripe_success.step_1'),
    t('stripe_success.step_2'),
    t('stripe_success.step_3'),
  ];

  return (
    <div style={{ minHeight: '100vh', background: C.cream, fontFamily: 'sans-serif', padding: '1.5rem 1rem' }}>
      <div style={{ maxWidth: 480, margin: '0 auto', paddingBottom: '3rem' }}>

        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🎉</div>
          <h1 style={{ fontFamily: 'Georgia, serif', color: C.sage, fontSize: '1.5rem', margin: 0 }}>
            {isClinic ? t('stripe_success.clinic_active') : t('stripe_success.patient_premium')}
          </h1>
        </div>

        {isClinic && (
          <>
            <div style={{ background: '#fff', borderRadius: 16, padding: '1.5rem', boxShadow: '0 2px 12px rgba(44,106,79,0.08)', marginBottom: '1rem' }}>
              <h3 style={{ color: C.carbon, fontFamily: 'Georgia, serif', margin: '0 0 1rem' }}>
                {t('stripe_success.next_steps')}
              </h3>
              {STEPS.map((text, idx) => (
                <div key={idx} style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.9rem', alignItems: 'flex-start' }}>
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: C.mintLt, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: C.sage, fontWeight: 700, fontSize: '0.85rem' }}>
                    {idx + 1}
                  </div>
                  <p style={{ margin: 0, color: C.carbon, fontSize: '0.9rem', lineHeight: 1.5 }}>{text}</p>
                </div>
              ))}
            </div>

            <div style={{ background: C.mintLt, borderRadius: 12, padding: '1rem', marginBottom: '1rem', fontSize: '0.85rem', color: C.carbon }}>
              {t('stripe_success.email_note_pre')} <strong>hola@veraglp.com</strong>
            </div>
          </>
        )}

        {!isClinic && (
          <div style={{ background: '#fff', borderRadius: 16, padding: '1.5rem', boxShadow: '0 2px 12px rgba(44,106,79,0.08)', marginBottom: '1rem', textAlign: 'center' }}>
            <p style={{ color: C.carbon, fontSize: '0.95rem', lineHeight: 1.6 }}>
              {t('stripe_success.subscription_active')}
            </p>
          </div>
        )}

        <button
          onClick={goHome}
          style={{ width: '100%', padding: '0.9rem', borderRadius: 8, border: 'none', background: C.sage, color: '#fff', fontSize: '1rem', fontWeight: 700, cursor: 'pointer' }}
        >
          {isClinic ? t('stripe_success.clinic_btn') : t('stripe_success.patient_btn')}
        </button>
      </div>
    </div>
  );
}
